'use strict';

var _require = require('lodash'),
    filter = _require.filter,
    reduce = _require.reduce;

var getWordCount = require('./get-word-count');

function getContentWordCount() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      blocks = _ref.blocks;

  var textBlocks = filter(blocks, function (_ref2) {
    var type = _ref2.type;
    return type !== 'atomic';
  });
  return reduce(textBlocks, function (count, _ref3) {
    var text = _ref3.text;
    return getWordCount(text) + count;
  }, 0);
}

module.exports = getContentWordCount;